import { GET, PATCH, POST } from "../../helper/official_website_restfunctions";


export const updateApplicantStatus = async (
    apply_id: any,
    data:any
  ) => {
    const path = `/join_us_page/${apply_id}`;
    return await PATCH({ apiUri: path, data })
      .then((result) => {
        return result[1];
      })
      .catch((err) => {
        console.log("error on fetching objective >", err);
        return err;
      });
  };